import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { PositionsHeader } from './PositionsHeader'
import { PositionsTable } from './PositionsTable/PositionsTable'
import { PositionListFilters } from './PositionListFilters/PositionListFilters'
import { ColumnsFilter } from './PositionsTable/ColumnsFilter/ColumnsFilter'

export const PositionsMain = () => {
  return (
    <>
      <PositionsHeader />
      <Box margin={3}>
        <Flex justifyContent="space-between" alignItems="center" mb={3}>
          <PositionListFilters />
          <ColumnsFilter />
        </Flex>
        <PositionsTable />
      </Box>
    </>
  )
}
